/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Evgenij Tyan
 * @version 1.1.0
 * @since 1.1.0
 */

import map from 'lodash/map';

import { icons } from '../../../assets';
import { FlexStyled } from '../Block/Flexbox';
import { ImgStyled } from '../Block/Img';
import { Select } from '../index';
import { IOptionItemProps } from '../Select/Select';
import {
    RangeMonthPickerHeaderStyled,
    RangeMonthPickerYearSelectLeftStyled,
    RangeMonthPickerYearSelectRightStyled, RangeMonthPickerYearSelectStyled,
} from './styled/RangeMonthPickerStyled';



export interface IConnectedProps {
    allowNextYear: boolean;
    allowPrevYear: boolean;
    changeYear: (v: number) => void;
    showYear: number;
    years: number[];
}

const RangeMonthPickerHeader = (props: IConnectedProps) => {

    const getYears = (): IOptionItemProps[] => {
        const years = map(props.years, year => ({
            label: year.toString(),
            value: year.toString(),
        }));

        return years as IOptionItemProps[];
    };

    const onSelectHandler = ({ value }: IOptionItemProps) => {
        const date = typeof value === 'number' ? value : parseInt(value);
        props.changeYear(date);
    };

    return (
        <RangeMonthPickerHeaderStyled>
            <FlexStyled
                alignItems='center'
                justifyContent='space-between'>

                <RangeMonthPickerYearSelectLeftStyled
                    data-name='selectArrowPrevYear'
                    isEnabled={props.allowPrevYear}
                    onClick={() => {
                    props.allowPrevYear && props.changeYear(props.showYear - 1)
                }}>
                    <ImgStyled
                        className="small"
                        src={props.allowPrevYear ? icons.arrowLeftIcon : icons.arrowLeftDisabledIcon}
                    />
                </RangeMonthPickerYearSelectLeftStyled>
                <RangeMonthPickerYearSelectStyled
                    data-name='selectPickerYear'
                >
                    <Select
                        kind="normal"
                        options={getYears()}
                        selectedOption={{
                            label: props.showYear.toString(),
                            value: props.showYear.toString(),
                        }}
                        onSelect={onSelectHandler}
                    />
                </RangeMonthPickerYearSelectStyled>
                <RangeMonthPickerYearSelectRightStyled
                    data-name='selectArrowNextYear'
                    isEnabled={props.allowNextYear}
                    onClick={() => {
                    props.allowNextYear && props.changeYear(props.showYear + 1)
                }}>
                    <ImgStyled
                        className="small"
                        src={props.allowNextYear ? icons.arrowRightIcon : icons.arrowRightDisabledIcon}
                    />
                </RangeMonthPickerYearSelectRightStyled>
            </FlexStyled>
        </RangeMonthPickerHeaderStyled>);
};

export default RangeMonthPickerHeader;
